import React from 'react';
import { Receipt } from '../../../../../../../types/clientReceipts';
import { formatCurrency, formatDate } from '../../../../../../../utils/formatters';
import './ReceiptCard.scss';

interface ReceiptCardProps {
    receipt: Receipt;
    onViewReview?: (receipt: Receipt) => void;
    onLeaveReview?: (receipt: Receipt) => void;
}

const ReceiptCard: React.FC<ReceiptCardProps> = ({ receipt, onViewReview, onLeaveReview }) => {
    const hasReview = receipt.review !== null && receipt.review !== undefined;

    return (
        <div className="receipt-card">
            <div className="receipt-header">
                <div className="receipt-info">
                    <h3>Recibo #{receipt.receipt_number || receipt.receipt_id}</h3>
                    <p className="receipt-date">{formatDate(receipt.timestamp)}</p>
                </div>
                <div className="receipt-total">
                    <span className="total-label">Total</span>
                    <span className="total-amount">{formatCurrency(receipt.total_payed)}</span>
                </div>
            </div>
            
            <div className="receipt-items">
                {receipt.selections.map((selection, index) => (
                    <div key={index} className="item-row">
                        <span className="item-qty">{selection.quantity}x</span>
                        <span className="item-name">{selection.name || selection.item_name || 'Item'}</span>
                        <span className="item-price">{formatCurrency(selection.price || selection.total_price || 0)}</span>
                    </div>
                ))}
            </div>

            {receipt.discount_amount && receipt.discount_amount > 0 && (
                <div className="receipt-discount">
                    <span>Descuento {receipt.discount_name}</span>
                    <span className="discount-value">-{formatCurrency(receipt.discount_amount)}</span>
                </div>
            )}

            {hasReview && onViewReview && (
                <button 
                    className="view-review-btn"
                    onClick={() => onViewReview(receipt)}
                >
                    Ver mi reseña
                </button>
            )}

            {!hasReview && onLeaveReview && (
                <button 
                    className="leave-review-btn"
                    onClick={() => onLeaveReview(receipt)}
                >
                    <span className="btn-icon">⭐</span>
                    <span className="btn-text">Dejar Reseña</span>
                </button>
            )}
        </div>
    );
};

export default ReceiptCard;
